import MuiDialog, { DialogProps as MUIDialogProps } from '@mui/material/Dialog';
import { useEffect, PropsWithChildren, useRef } from 'react';
import { atom, selector, RecoilState, RecoilValue, useSetRecoilState } from 'recoil';
import { Colors } from 'styles';

export type DialogProps = PropsWithChildren<{
  variant?: 'dark' | 'light';
  open?: boolean;
}> &
  MUIDialogProps;

export const dialogOpenCount: RecoilState<number> = atom<number>({
  key: 'dialogOpenCount',
  default: 0,
});

export const isDialogOpenSelector: RecoilValue<boolean> = selector({
  key: 'isDialogOpen',
  get: ({ get }) => {
    return get(dialogOpenCount) > 0;
  },
});

const Dialog = ({ variant = 'dark', ...rest }: DialogProps) => {
  const setDialogOpenCount = useSetRecoilState(dialogOpenCount);
  const wasOpen = useRef<boolean>(false);

  useEffect(() => {
    let decremented = false;

    if (rest.open) {
      setDialogOpenCount((count) => count + 1);
      wasOpen.current = true;
    } else {
      setDialogOpenCount((count) => Math.max(0, count - 1));
      wasOpen.current = false;
      decremented = true;
    }

    return () => {
      if (wasOpen.current && !decremented) {
        setDialogOpenCount((count) => Math.max(0, count - 1));
        wasOpen.current = false;
      }
    };
  }, [rest.open, setDialogOpenCount]);

  return (
    <MuiDialog
      {...rest}
      sx={{
        '& .MuiDialogContent-root': {
          padding: '0 0 3rem 0',
        },
      }}
      slotProps={{
        ...rest.slotProps,
        paper: {
          ...rest.slotProps?.paper,
          sx: {
            width: 450,
            p: '2rem',
            backgroundColor: variant === 'light' ? Colors.gray10 : Colors.gray2,
            color: variant === 'light' ? Colors.gray1 : Colors.gray10,
            ...(rest.slotProps?.paper as any)?.sx,
          },
        },
      }}
    />
  );
};
export default Dialog;
